import { stabilityApi } from '@/api';

/**
 * Mirrors normalizeMatrix in the API (matrix-normalization.ts): trim, collapse
 * inner whitespace, lowercase. Used only to compare a typed value against the
 * `matrixNorm` the API already returns on each condition — never to send.
 */
export const normalizeMatrix = (raw) => {
  const matrix = (raw || '').trim().replace(/\s+/g, ' ');
  return matrix ? matrix.toLowerCase() : null;
};

/**
 * Resolves the condition id a match should point at, reusing an existing
 * condition whenever the triple already exists on this configuration and
 * creating one only otherwise. This is what keeps the clone from duplicating
 * conditions, and what avoids the 409 the API answers on the uniqueness
 * constraint UNIQUE(configid, temperature, humidity, matrixNorm).
 */
export default async function resolveConditionId(configId, conditions, input) {
  const humidity = input.humidity ?? null;
  const matrixNorm = normalizeMatrix(input.matrix);

  const existing = (conditions || []).find(
    (condition) =>
      condition.temperature === input.temperature &&
      (condition.humidity ?? null) === humidity &&
      (condition.matrixNorm ?? null) === matrixNorm
  );
  if (existing) return existing.id;

  const { data } = await stabilityApi.createCondition(configId, {
    temperature: input.temperature,
    humidity,
    // Empty means NULL, never an empty string; the API normalizes the rest
    matrix: (input.matrix || '').trim() || null,
  });
  return data.id;
}
